/**
 * Shared frozen references for selector fallbacks.
 *
 * Using `[]` or `{}` inline in a selector's return path creates a new reference
 * on every call. We do this a lot with memoized selectors that use the
 * byWorkspace pattern and thus have nullish coalescence fallbacks. ex:
 *
 *	const selectArrayData= (state, workspaceId) =>
 *		state.dataSlice.byWorkspace[workspaceId] ?? []
 *
 * This breaks Reselect memoization and triggers React-Redux's
 * inputStabilityCheck warnings. Import these instead, and use like so:
 *
 * 	const selectArrayData= (state, workspaceId) =>
 * 		state.dataSlice.byWorkspace[workspaceId] ?? EMPTY_ARRAY
 *
 * Frozen so accidental mutation surfaces as an error in dev rather than
 * silently corrupting the shared reference for every other consumer.
 */
export const EMPTY_ARRAY = Object.freeze([])
export const EMPTY_OBJECT = Object.freeze({})